module.exports = __webpack_public_path__ + "static/media/arrow-send-context.46e31f54.svg";